import script from "./UpdateProfilePage.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateProfilePage.vue?vue&type=script&setup=true&lang=js"

import "./UpdateProfilePage.vue?vue&type=style&index=0&id=b9e8072a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9e8072a"]])

export default __exports__